import React, { useState } from "react";
import "./HumanexFAQ.css";

const FAQ_DATA = [
  {
    question: "What is Humanex AI?",
    answer:
      "Humanex AI is an intelligent HR companion designed to help organizations manage people operations efficiently by providing insights, automation, and guidance."
  },
  {
    question: "How does Humanex AI help HR teams?",
    answer:
      "Humanex AI helps HR teams by analyzing workforce data, automating repetitive tasks, providing real-time insights, and guiding users through HR workflows."
  },
  {
    question: "Is Humanex AI secure?",
    answer:
      "Yes. Humanex AI follows enterprise-grade security standards with encrypted data, strict access controls, and compliance with industry best practices."
  },
  {
    question: "Does Humanex AI replace HR professionals?",
    answer:
      "No. Humanex AI is built to support HR professionals, not replace them. It enhances decision-making and reduces manual work."
  },
  {
    question: "Can Humanex AI integrate with existing HR tools?",
    answer:
      "Yes. Humanex AI integrates seamlessly with popular HR platforms, ensuring smooth data flow with minimal disruption."
  }
];

const HumanexFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faci-wrapper">
      {/* Header */}
      <div className="faci-header">
        <h2>
          Frequently Asked Questions about{" "}
          <span className="faci-highlight">Humanex AI</span>
        </h2>
        <p>
          Everything you need to know about how Humanex AI works and supports your HR team.
        </p>
      </div>

      {/* FAQ List */}
      <div className="faci-list">
        {FAQ_DATA.map((item, index) => (
          <div
            key={index}
            className={`faci-item ${openIndex === index ? "open" : ""}`}
          >
            <button
              className="faci-question"
              onClick={() => toggle(index)}
              aria-expanded={openIndex === index}
            >
              <span>{item.question}</span>
              <span className="faci-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </button>

            <div className="faci-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HumanexFAQ;
